var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleFitHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9137_5477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5834 11.638L3.94369 12.947L6.88146 10.131L5.5326 8.822L4.91533 8.228C4.42379 7.755 4.16088 7.139 4.16088 6.468C4.16088 5.885 4.36664 5.357 4.721 4.939C5.2011 4.356 5.93268 3.982 6.75572 3.982C7.45301 3.982 8.09314 4.246 8.5961 4.719L9.20195 5.28L10.5622 6.6L13.5114 3.784L12.1397 2.475L11.5224 1.903C10.2993 0.726 8.61897 0 6.75572 0C3.01778 0 0 2.904 0 6.479C0 7.37 0.182896 8.217 0.525826 8.998C0.868755 9.779 1.36029 10.472 1.97756 11.055L2.5834 11.638Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31593 13.4421L13.5111 9.4271L10.5619 6.6001L6.88112 10.1311L3.94336 12.9471L5.52084 14.4761L6.88112 15.7741L8.29857 14.4101",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4372 19.3161L23.0671 12.9471L20.1179 10.1311L13.4994 16.4891L9.81862 12.9581L6.88086 15.7741L10.5616 19.3161L10.5502 19.3271L13.4994 22.0001L16.4486 19.3161H16.4372Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0227 11.055C26.3944 9.73502 27.1832 7.71102 26.966 5.66502C26.6459 2.56302 23.9711 0.231022 20.7247 0.0220217C18.6785 -0.109978 16.8038 0.627022 15.4778 1.90302L10.5625 6.60002L13.5003 9.42702L18.4156 4.71902C19.01 4.15802 19.833 3.89402 20.6789 4.02602C21.7763 4.19102 22.6679 5.06002 22.8165 6.11602C22.9308 6.90802 22.6565 7.67802 22.0735 8.23902L20.1188 10.131L23.068 12.947L25.0227 11.055Z",
    fill: "#4285F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9137_5477"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleFitHeart);
export default __webpack_public_path__ + "static/media/google-fit-heart.031afa7761e7a539f907de550e4aa38d.svg";
export { ForwardRef as ReactComponent };